import styled from 'styled-components'
import { Typography } from '@mui/material'
import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  align-items: center;
  padding-bottom: 1rem;
`

export const CustomTextField = styled(TextFieldMui)`
  height: 2.5rem !important;
  margin: 0 !important;
`

export const ProductInfoBox = styled(Typography)`
  width: 100%;
  background-color: #839BCB;
  font-weight: bold !important;
  font-size: 16px !important;
  border: 1px;
  border-style: solid;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  padding: 8px 8px 8px 8px;
`

export const CustomButton = styled(ButtonMui)`
`

export const BodyModalAlert = styled.div`
  display: flex;
  width: 100%;
  padding: 15px;
`

export const AlertMessageBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  word-wrap: break-word;
`

export const AlertMessage = styled.span`
`

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ContainerRows = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 46vh;
  overflow-y: auto;
`

export const Row = styled.div`
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  padding-left: .2rem;
  padding-right: .2rem;
  padding-top: .1rem;
  padding-bottom: .1rem;
`

export const Column = styled.div<{ minWidth: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: ${({ minWidth }) => minWidth};
`

export const CustomTableTextField = styled(TextFieldMui)`
  width: 90% !important;
  margin: 0 !important;
`

export const QuantityInfoBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: 1rem;
  margin-right: 1rem;
`

export const QuantityInfoText = styled(Typography)`
  font-size: 16px;
`

export const CountedQuantity = styled(Typography)`
  width: 100%;
  font-size: 16px;
  display: flex;
  justify-content: flex-end;
  margin-right: 1rem;
`

export const CountedQuantityError = styled(CountedQuantity)`
  color: red;
  margin-right: 1rem;
  margin-top: -1.5rem !important;
`

export const BoxInfos = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: 1rem;
  margin-right: 1rem;
`

export const InfoText = styled(Typography)`
  font-size: 16px;
`
